/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Inspector_CameraInputs */

const en_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera`)
};

const ar_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الكاميرا`)
};

const bn_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ক্যামেরা`)
};

const de_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera`)
};

const es_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cámara`)
};

const fr_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Appareil`)
};

const pt_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Câmera`)
};

const zh_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`相机`)
};

const tr_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamera`)
};

const ru_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Камера`)
};

const pl_image_inspector_camera = /** @type {(inputs: Image_Inspector_CameraInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aparat`)
};

/**
* | output |
* | --- |
* | "Camera" |
*
* @param {Image_Inspector_CameraInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const image_inspector_camera = /** @type {((inputs?: Image_Inspector_CameraInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Inspector_CameraInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_image_inspector_camera(inputs)
	if (locale === "bn") return bn_image_inspector_camera(inputs)
	if (locale === "de") return de_image_inspector_camera(inputs)
	if (locale === "es") return es_image_inspector_camera(inputs)
	if (locale === "fr") return fr_image_inspector_camera(inputs)
	if (locale === "pt") return pt_image_inspector_camera(inputs)
	if (locale === "zh") return zh_image_inspector_camera(inputs)
	if (locale === "tr") return tr_image_inspector_camera(inputs)
	if (locale === "ru") return ru_image_inspector_camera(inputs)
	if (locale === "pl") return pl_image_inspector_camera(inputs)
	return en_image_inspector_camera(inputs)
});